//https://github.com/Offbeatmammal/jsErrLog
var config = {
    //js版本号
    version:"0.0.3",
    // 避免冲突加的前缀
    pre:"xlog",
    // 开启后,不会发服务器,只会打印在控制台
    debugMode:false,
    // 环境
    isDevelop:false,
    // 报错计数
    err_i : 0,
    // 默认取样频率
    sample: 1,
    // 日志服务器地址
    //remoteUrl : "http://jserrlog.appspot.com/logger.js",
    remoteUrl:"//gubajslog.eastmoney.com/xlog.gif",
    // 页面url的get参数里需要忽略并不上报服务器的参数,这里的参数是指key-value对中的key
    qsIgnore : new Array(),
    // 黑名单,忽略的域名(域名是指报错js资源地址的域名)
    domainIgnore : new Array(),
    // 白名单,只处理的域名(域名是指报错js资源地址的域名)
    domainWhitelist : new Array(),
    // 每个页面报错上报的总条数(jsErrorLogger用)
    maxRep : 50,
    // 是否返回告诉浏览器是否调用浏览器原生处理错误(去报红)
    trapErrors : false,
    // 浏览器控制台打印
    logToConsole : false,
    // 跨域类报错
    ignoreCrossOriginErrors : false,
    // 每个页面生成一个UUID(可自定义)
    guid : "",
    // res记录的duration阈值
    res_duration : 1000,
    // 页面onload值记录阈值
    page_load_slow_time : 5000,

    //初始化
    init:function(){
        if (this.qsIgnore.length > 0) {
            // 都先转成小写
            for (var i=0,ilen=this.qsIgnore.length; i<ilen; i++) {
                this.qsIgnore[i] = this.qsIgnore[i].toLowerCase();
            }
        }
        if(window.location.href.indexOf(":9")>=0){
            this.isDevelop=true
        }
    }
}

module.exports = config;


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 0
// module chunks = 0 1 2